import React, { useState } from 'react';
import { Header, Footer, Chatbot } from './components';
import { 
  Accueil, 
  Nitrokym, 
  Produits, 
  Certification, 
  Devis, 
  Contact 
} from './pages';
import './App.css';

const NitrokymWebsite = () => {
  const [currentPage, setCurrentPage] = useState('accueil');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [chatbotOpen, setChatbotOpen] = useState(false);

  // Pages du site
  const pages = [
    { id: 'accueil', label: 'Accueil' },
    { id: 'nitrokym', label: 'Nitrokym' },
    { id: 'produits', label: 'Nos Produits' },
    { id: 'certification', label: 'Certification ISO' },
    { id: 'devis', label: 'Demande de Devis' },
    { id: 'contact', label: 'Contact' }
  ];

  // Données de Nitrokym
  const usine = {
    nom: 'NITROKYM',
    description: 'Usine spécialisée dans la chimie des chlor-alkalis',
    adresse: 'Nouvelle Zone Industrielle Djebel oust',
    ville: 'Zaghouane, Tunisie',
    telephone: '+216 70 279 320',
    email: 'contact@nitrokym.com.tn',
    commercial: 'commercial@nitrokym.com.tn',
    fondation: 2015,
    employes: '200+',
    specialite: 'Production de produits chimiques inorganiques essentiels',
    certifications: ['ISO 9001:2015']
  };

  // Produits de Nitrokym
  const produits = [
    { 
      nom: 'Acide Chlorhydrique', 
      formule: 'HCl', 
      concentration: '30-33%',
      usage: 'Traitement de surface, industrie chimique, pétrochimie, traitement des minerais',
      description: 'Acide fort essentiel utilisé dans divers procédés industriels. Qualité technique supérieure.',
      emballage: 'Camions-citernes',
      applications: [
        'Décapage des métaux',
        'Régulation du pH',
        'Synthèse chimique',
        'Traitement des minerais'
      ]
    },
    { 
      nom: 'Soude Caustique 50%', 
      formule: 'NaOH', 
      concentration: '50%',
      usage: 'Industrie chimique, textile, papier, détergents, traitement des eaux',
      description: 'Base forte de haute pureté utilisée dans la fabrication de nombreux produits industriels.',
      emballage: 'Fûts 1000L, Camions-citernes',
      applications: [
        'Fabrication de détergents',
        'Traitement des pâtes à papier',
        'Industrie textile',
        'Traitement des eaux usées'
      ]
    },
    { 
      nom: 'Hypochlorite de Sodium', 
      formule: 'NaClO', 
      concentration: '48-50%',
      usage: 'Traitement de l\'eau, désinfection, blanchiment, assainissement',
      description: 'Solution désinfectante puissante et efficace pour le traitement des eaux et la désinfection.',
      emballage: 'Fûts 1000L, Camions-citernes',
      applications: [
        'Traitement de l\'eau potable',
        'Désinfection des piscines',
        'Blanchiment textile',
        'Assainissement industriel'
      ]
    }
  ];

  // Certification ISO 9001
  const certification = {
    nom: 'ISO 9001:2015',
    titre: 'Système de Management de la Qualité',
    description: 'Nitrokym est certifiée ISO 9001:2015, garantissant l\'excellence de nos processus de production et notre engagement envers la satisfaction client.',
    avantages: [
      'Processus de production optimisés',
      'Contrôle qualité rigoureux à chaque étape',
      'Amélioration continue des performances',
      'Satisfaction client garantie',
      'Traçabilité complète des produits'
    ],
    dateCertification: '19 Mars 2024',
    dateRenouvellement: '18 Mars 2027',
    organisme: 'Bureau Veritas Certification'
  };

  // Chiffres clés
  const chiffres = [
    { nombre: '200+', label: 'Employés Qualifiés' },
    { nombre: '3', label: 'Produits Principaux' },
    { nombre: '20+', label: 'Années d\'Expérience' },
    { nombre: 'ISO 9001', label: 'Certification Qualité' }
  ];

  // Afficher la page active
  const renderPage = () => {
    switch (currentPage) {
      case 'accueil':
        return <Accueil 
          setCurrentPage={setCurrentPage} 
          usine={usine} 
          produits={produits}
          chiffres={chiffres}
          certification={certification}
        />;
      case 'nitrokym':
        return <Nitrokym usine={usine} />;
      case 'produits':
        return <Produits produits={produits} setCurrentPage={setCurrentPage} />;
      case 'certification':
        return <Certification certification={certification} />;
      case 'devis':
        return <Devis produits={produits} usine={usine} />;
      case 'contact':
        return <Contact usine={usine} />;
      default:
        return <Accueil 
          setCurrentPage={setCurrentPage} 
          usine={usine} 
          produits={produits}
          chiffres={chiffres}
          certification={certification}
        />;
    }
  };

  return (
    <div className="app">
      <Header 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage} 
        pages={pages}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        nomUsine="Nitrokym"
      />
      <main className="main">
        {renderPage()}
      </main>
      <Footer 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage} 
        pages={pages} 
        usine={usine}
        certification={certification}
      />
      <Chatbot 
        chatbotOpen={chatbotOpen}
        setChatbotOpen={setChatbotOpen}
        setCurrentPage={setCurrentPage}
        usine={usine}
      />
    </div>
  );
};

// ⚠️ IMPORTANT : Notez bien le nom d'export ici
export default NitrokymWebsite;  // ← CE NOM EST DIFFÉRENT DE Nitrokym